import React, { useState, useEffect } from "react";
import { useWatchState } from "@/store";
import { Modal, Descriptions, Divider, Button, Icon, Collapse, Tabs } from "antd";
import "./style.less";
import achievement1 from "./images/achievement1.png";
const { Panel } = Collapse;
const NAME = "evaLuateNewCase";
const App = () => {
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME]);
    const { title = "", show, hide, width = 1095, height = 600, ServerImg } = modalProps;
    const { TabPane } = Tabs;
    function callback(key) {
        console.log(key);
    }

    return (
        <Modal
            visible={show}
            width={width}
            height={height}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
                {ServerImg == 'achievement1' &&
                    <div class="mask" id="popupWrap">
                        <div class="popup-box">
                            <div class="popup-header">
                                <div class="header-title">产业园区招商项目评价（保定国家高新区）</div>
                                <button class="close-btn" id="hideBtn" onClick={hide}>×</button>
                            </div>
                            <div class="popup-content">
                                <div class="info-block">
                                    <p class="serviceTitle">评价服务对象：保定国家高新区</p>
                                    <p class="serviceTitle">评价业务内容：招商评审入库项目</p>
                                    <p class="dir-title">评价项目目录</p>
                                </div>
                                <div class="project-list">
                                    <ol>
                                        <li>智能配电产业基地</li>
                                        <li>电力设备生产制造项目</li>
                                        <li>大参林河北总部项目</li>
                                        <li>华安产业·保定高新数智谷项目</li>
                                        <li>环境保护专用设备研发生产项目</li>
                                        <li>联东 U 谷·保定高新科技企业港</li>
                                        <li>华北（保定）卫星运营中心</li>
                                        <li>长安重工华北生产基地</li>
                                        <li>企智询大数据服务中心</li>
                                        <li>河北保定市网络安全运营中心项目</li>
                                        <li>保定直播电商产业园区</li>
                                        <li>抖音电商北方瓷区保定直播基地</li>
                                        <li>数字保定项目</li>
                                        <li>保定数字产业创新中心项目</li>
                                        <li>保定大数据产业公共服务平台</li>
                                        <li>数字保定</li>
                                        <li>天津大学生态环境产业研究院</li>
                                        <li>保定洛奇医学检验实验室项目</li>
                                        <li>智慧医疗医共体信息平台</li>
                                        <li>基因重组人血清白蛋白（rHSA）等项目产业化研发</li>
                                        <li>跨境电商基地</li>
                                        <li>电力系统通信监控产业化项目</li>
                                        <li>电子芯片式互感器生产项目</li>
                                        <li>智能电网数字化智慧配电设备项目</li>
                                        <li>智能化感应加热高端装备制造项目</li>
                                        <li>精密研磨抛光材料</li>
                                        <li>现场热再生机组及成套技术</li>
                                        <li>推进数字产业化的数据要素服务平台</li>
                                        <li>保定市人力资源服务基地</li>
                                        <li>保定市文旅资产数字信息化管理运营平台项目</li>
                                        <li>研发中心及北方智能制造基地</li>
                                        <li>数字化生态应用大数据中心项目</li>
                                        <li>东华软件(保定)有限公司落地</li>
                                        <li>中国电子（保定）PKS生态创新中心</li>
                                        <li>年产165吨碳化硅合成粉料生产线建设</li>
                                        <li>美尔嵩太阳能光伏组件</li>
                                        <li>新型建筑节能材料</li>
                                        <li>酸性氧化电位水</li>
                                        <li>集成电路/液晶面板精密装备及零部件的研发、修复及生产基地</li>
                                        <li>年产2000台套智能泵组及远程控制系统项目</li>
                                        <li>智能配电设备</li>
                                        <li>年产50套风电叶片及其配套设施建设项目</li>
                                        <li>储能设备生产项目</li>
                                        <li>复合生物液态肥项目</li>
                                        <li>数字保定建设项目</li>
                                        <li>清华同方华北制造基地项目</li>
                                        <li>HVDC·RS直流远程智慧供电系统</li>
                                        <li>电力变压器设备制造项目</li>
                                        <li>年产2000套自动装车系统项目</li>
                                        <li>锂离子电池及储能项目</li>
                                        <li>智能财务机器人项目</li>
                                        <li>建筑节能玻璃生产项目</li>
                                        <li>CHWDAHM数据管理医院法项目</li>
                                        <li>数字文化建设项目</li>
                                        <li>中移建设有限公司河北保定分公司项目</li>
                                        <li>保定市级电商公共服务平台-保定电商产业园</li>
                                        <li>智慧体育系统的研发与应用</li>
                                        <li>大数据应用与数据要素市场化联合实验室</li>
                                        <li>凝血特殊项目与核心原材料的开发与量产</li>
                                        <li>干细胞科研及产业化基地</li>
                                        <li>变压器铁芯智能制造项目</li>
                                        <li>年产25000台智能化配电终端设备产业基地</li>
                                        <li>“中国电谷•光储充换检低碳一体化微电网”示范站</li>
                                        <li>远程监控智能配电柜项目</li>
                                        <li>京津冀新能源汽车动力电池梯次回收利用项目</li>
                                        <li>神经外科高端医疗器械项目</li>
                                        <li>基因重组人血清白蛋白（rHSA）等项目产业化研发项目</li>
                                        <li>新型检验检测产品研发及产业化项目</li>
                                        <li>保定市“数投云”建设项目</li>
                                        <li>高性能算力网络关键技术研究</li>
                                        <li>保定市城市生命线安全监管建设项目</li>
                                        <li>聚乳酸降解材料的应用</li>
                                        <li>生物医学实验室</li>
                                        <li>添加剂生产项目</li>
                                        <li>智能多模态影像引导穿刺机器人系统</li>
                                        <li>高性能医疗器械研发中心建设项目</li>
                                        <li>“科创中国”保定云</li>
                                        <li>保定市邮政快递及供销集配双基地项目</li>
                                        <li>年产1500套智能配电装备研发生产基地项目</li>
                                        <li>节能型变压器研发制造基地项目</li>
                                        <li>高端电力配电装备智能制造产业基地项目</li>
                                        <li>高低压成套设备研发生产线项目</li>
                                        <li>智能心电衣</li>
                                        <li>双怡空调压缩机不锈钢代铜零配件研发制造项目</li>
                                        <li>研究生工作站及智慧交通产品研发生产基地项目</li>
                                        <li>澳诺（中国）制药有限公司华北生产基地项目</li>
                                        <li>基因重组人血清白蛋白项目</li>
                                        <li>零碳园区+智慧能源+智能制造产业融合试点示范项目</li>
                                        <li>电力变压器设备制造项目</li>
                                        <li>智能制造汽配零部件产业园项目</li>
                                        <li>年产5000台套高端电力配电装备智能制造项目</li>
                                        <li>年产 1500（台）套 10Kv 高能效变压器项目</li>
                                        <li>年产5000台套过电压抑制成套设备项目</li>
                                        <li>年产18000吨番茄酱罐头扩产项目</li>
                                        <li>罗普特（保定）科技产业园</li>
                                        <li>储能及电力电子生产基地项目</li>
                                        <li>年产200万片嵌入式技术核心板生产基地项目</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                }
        
        </Modal>
    );
}

export default App;